module.exports = __webpack_public_path__ + "img/av231.54d7cbdf.png";